import { render, staticRenderFns } from "./FilterMenuItem.vue?vue&type=template&id=5d2f711e&scoped=true&"
import script from "./FilterMenuItem.vue?vue&type=script&lang=js&"
export * from "./FilterMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterMenuItem.vue?vue&type=style&index=0&id=5d2f711e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f711e",
  null
  
)

export default component.exports